export default "__VITE_ASSET__D3ZX1Hs9__"